import React, {Component} from 'react'
import {Card, CardBody, CardTitle, Button} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast, ToastContainer} from "react-toastify"
import {withRouter} from 'react-router-dom'

import mutation from '../../../queries/server/mutations/send_forgot_password_link'


class ForgotPassword extends Component {

    state = {
        username: ''
    }

    render() {
        return (
            <div className="container-fluid flex-fullheight">
                <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
                    <Card className="shadow-sm p-3 mb-5 bg-white rounded login-card">
                        <CardTitle>Forgot Password?</CardTitle>
                        <div className="d-flex align-items-center justify-content-center">
                            <Mutation mutation={mutation}>
                                {(mutationFunc, {loading}) => (
                                    <AvForm
                                        className="d-flex flex-column"
                                        style={{flex: 1}}
                                        onValidSubmit={() => {
                                            mutationFunc({variables: {...this.state}})
                                                .then(() => {
                                                    toast.success('Password Reset Link Sent to Your Email', {autoClose: 2000})
                                                })
                                                .catch(e => {
                                                    toast.error(e.message, {autoClose: false})
                                                })
                                        }}
                                    >
                                        <AvField
                                            required
                                            name="username"
                                            label="Username*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({username: evt.target.value})}
                                        />

                                        <div className="d-flex flex-row justify-content-between">
                                            <Button
                                                size="sm"
                                                color="link"
                                                onClick={() => this.props.history.push('/login')}
                                            >
                                                Back to Login
                                            </Button>
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={loading}
                                            >
                                                {loading ? 'Sending your Password Reset Link...' : 'Send Reset Password Link'}{' '}
                                                {loading && <FontAwesomeIcon
                                                    color="#fff"
                                                    icon="spinner"
                                                    spin
                                                />}
                                            </Button>
                                        </div>
                                    </AvForm>
                                )}

                            </Mutation>
                        </div>
                    </Card>
                </div>
                <ToastContainer/>
            </div>
        )
    }

}

ForgotPassword = withRouter(ForgotPassword)

export default ForgotPassword